import { createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import { createSession } from '../../services/smartthermostat/SessionsService';

export const useSessionsCreateSession = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createSession, 'requestBody', 'data'),
      'data',
      'id',
      'text',
      'signature',
      'prefix',
      'productId',
      'timeZone',
      'longitude',
      'latitude',
      'outOfBoxEnabled',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'id',
          'text',
          'signature',
          'prefix',
          'productId',
          'timeZone',
          'longitude',
          'latitude',
          'outOfBoxEnabled',
        ],
      },
    ],
  },
);
